import { isPackageRestrictionEnabled } from "~/common/components/PackageRestrictionContext/utils/isPackageRestrictionEnabled";
import { PDP_RESTRICTION_URL_PARAM } from "~/common/components/PackageRestrictionContext/utils/constants";

export const augmentPDPUrlWithRestriction = (url: string, query: string) => {
  if (!isPackageRestrictionEnabled()) {
    return url;
  }
  const containsQuery = url.includes("?");
  return url + (containsQuery ? "&" : "?") + PDP_RESTRICTION_URL_PARAM + "=" + prepareRestrictionValue(query);
};

export const prepareRestrictionValue = (query: string) => {
  return query.replace(/-/g, "");
};
